import React, { useEffect, useRef, useState } from "react";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import "pdfjs-dist/build/pdf.worker.mjs";
import { BASE_URL } from "Utils/URLs";

function stripHash(url) {
  const s = String(url || "");
  const i = s.indexOf("#");
  return i >= 0 ? s.slice(0, i) : s;
}

function toProxyUrl(url) {
  const u = String(url || "");
  if (!u) return u;
  if (u.startsWith("blob:")) return u;
  if (/^https?:\/\//i.test(u) && (u.includes("storage.googleapis.com") || u.includes(".storage.googleapis.com"))) {
    const base = String(BASE_URL || "").replace(/\/$/, "");
    if (!base) return u;
    return `${base}/file/proxy?url=${encodeURIComponent(u)}`;
  }
  return u;
}

export default function PdfCanvasPreview({ url }) {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    const container = containerRef.current;
    const cleanUrl = toProxyUrl(stripHash(url));
    if (!container || !cleanUrl) return;

    let cancelled = false;
    let loadingTask = null;

    const run = async () => {
      try {
        setErr("");
        setLoading(true);
        container.innerHTML = "";

        loadingTask = pdfjsLib.getDocument(cleanUrl);
        const pdf = await loadingTask.promise;
        if (cancelled) return;

        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          if (cancelled) return;
          const page = await pdf.getPage(pageNum);
          if (cancelled) return;

          const viewport = page.getViewport({ scale: 1.5 });
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          if (!ctx) continue;

          canvas.width = Math.floor(viewport.width);
          canvas.height = Math.floor(viewport.height);
          canvas.style.width = "100%";
          canvas.style.height = "auto";
          canvas.style.display = "block";

          const wrapper = document.createElement("div");
          wrapper.style.padding = "12px";
          wrapper.style.background = "#fff";
          wrapper.style.borderBottom = "1px solid #eee";
          wrapper.appendChild(canvas);
          container.appendChild(wrapper);

          await page.render({ canvasContext: ctx, viewport }).promise;
        }
      } catch (e) {
        if (!cancelled) setErr("Failed to load PDF");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();

    return () => {
      cancelled = true;
      try {
        loadingTask?.destroy?.();
      } catch (_) {}
      if (containerRef.current) containerRef.current.innerHTML = "";
    };
  }, [url]);

  return (
    <div style={{ height: "100%", overflow: "auto", background: "#f7f7f7" }}>
      {loading && <div style={{ padding: 12, textAlign: "center", color: "#777" }}>Loading PDF...</div>}
      {err ? <div style={{ padding: 12, textAlign: "center", color: "#d32f2f" }}>{err}</div> : null}
      <div ref={containerRef} />
    </div>
  );
}

